'use client';
import React from 'react';
import Button from '@elements/button';
import ArrowLeftIcon from '@icons-components/arrow-left-icon';
import ArrowRightIcon from '@icons-components/arrow-right-icon';
import { useRouter } from 'next-nprogress-bar';
import { useDispatch } from 'react-redux';
import routes from '@routes';
import { PharmaciesActions } from '@store/pharmacies/pharmacies-actions';
import { useParams } from 'next/navigation';
import getParseRoute from '@utils/helpers/parse-route';
import { LocaleTypes } from '@dictionaries-types';

const ServiceItemButton = ({ isActive, route, buttonTitle } : {isActive: boolean, route: string, buttonTitle: any}) => {
  const { lang } = useParams<{lang: LocaleTypes}>();
  const router = useRouter();
  const dispatch = useDispatch();
  const handleSelectCityModal = (route?: string) => {
    if (route === routes['route.users.index'] || route === routes['route.products.index']) {
      router.push(getParseRoute({ pathname: route, locale: lang }));
    } else {
      dispatch(PharmaciesActions.setCityModal({ open: true }));
      if (route) {
        dispatch(PharmaciesActions.setCityHref({ href: route }));
      }
    }
  };

  return (
    <Button
      disabled={!isActive}
      onClick={() => handleSelectCityModal(route)}
      size={'large'}
      variant={'text'}
      fontType={'medium'}
      endAdornment={lang === 'fa' ? <ArrowLeftIcon/> : <ArrowRightIcon />}
      className={'!p-0'}
    >
      {buttonTitle.order}{!isActive ? buttonTitle.inActive : null}
    </Button>
  );
};

export default ServiceItemButton;
